<template>
    <div class="try-rocketchart">
        <div class="try-rocketchart__wrapper">
            <section class="left-panel">
                <div class="typographies-display-brand-large left-panel__title secondary-blue">
                    {{ $l10n.__('Anticipez enfin votre trésorerie en toute simplicité !') }}
                </div>
                <ImgSvg class="underline">
                    <Underline />
                </ImgSvg>

                <ul class="left-panel__content">
                    <li v-for="(item, index) in content" :key="index" class="left-panel__item">
                        <span class="typographies-paragraph-large-semibold">
                            {{ item.main }}
                        </span>
                        <span class="typographies-paragraph-large-regular">
                            {{ item.second }}
                        </span>
                    </li>
                </ul>

                <div class="left-panel__links flex-row">
                    <CompassTooltip :disabled="!tryRocketchartIsDisabled" placement="bottom-start">
                        <template #content> <span v-html="tooltipContent" /></template>
                        <CompassButton
                            ref="ButtonConfirm"
                            :label="$t.__('cashflow.TryRocketchart.try_for_free')"
                            type="primary"
                            size="large"
                            :disabled="tryRocketchartIsDisabled"
                            class="link-btns__button-confirm"
                            @click="tryRocketchart()"
                        />
                    </CompassTooltip>

                    <CompassButton
                        ref="ButtonContact"
                        :label="$t.__('common.actions.ask_demo')"
                        size="large"
                        type="secondary"
                        class="link-btns__button-contact"
                        @click="toRocketchart(true)"
                    />
                </div>
            </section>
            <section class="right-panel">
                <img src="/ressources/logged/img/cashflow/sellsy-rocketchart-integration.svg" />
            </section>
        </div>
    </div>
</template>

<script>
import Underline from 'vcomponents/imgs/ImgUnderlineUltraBlueMarine.vue';
import ImgSvg from 'vcomponents/imgs/ImgSvg.vue';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        Underline,
        ImgSvg,
    },
    props: {
        state: {
            type: Object,
            required: true,
            default: () => {},
        },
    },

    data() {
        return {
            content: [
                {
                    main: this.$l10n.__('Suivez votre trésorerie en temps réel'),
                    second: this.$l10n.__('sans aucune action manuelle ni erreur de saisie'),
                },
                {
                    main: this.$l10n.__('Enrichissez automatiquement vos prévisions'),
                    second: this.$l10n.__(
                        'avec vos encours de facturation et vos achats pour vous simplifier la vie',
                    ),
                },
                {
                    main: this.$l10n.__('Créez vos budgets prévisionnels'),
                    second: this.$l10n.__(
                        'à 3, 6, 12 ou 24 mois pour fixer vos objectifs et comparez avec le Réalisé en 1 clic',
                    ),
                },
                {
                    main: this.$l10n.__('Prenez les meilleures décisions'),
                    second: this.$l10n.__(
                        'grâce au multi-scénarios prévisionnels pour arbitrer vos choix stratégiques',
                    ),
                },
            ],
        };
    },
    computed: {
        tryRocketchartIsDisabled() {
            return !this.state?.canActivateTrial && !this.state?.isAdmin;
        },
        tooltipContent() {
            return this.$l10n.__(
                'Privilège insuffisant, contactez-votre administrateur%(br)s ou demandez une démo afin de découvrir comment%(br)s le module trésorerie peut vous aider au quotidien.',
                { br: '<br />' },
            );
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),

        toRocketchart(isDemo = true) {
            window.location.href = isDemo
                ? 'https://rocketchart.co/reserver-une-demo/'
                : this.state?.activationUrl;
        },
        // Admin only
        tryRocketchart() {
            if (this.state?.canActivateTrial && this.state?.activationUrl) {
                this.toRocketchart(false);
            } else if (this.state?.isTrialExpired) {
                this.displayExpiration();
            } else {
                this.callPopup();
            }
        },

        callPopup() {
            this.open({
                key: 'cashflowPopupWarning',
                props: {},
            });
        },

        displayExpiration() {
            this.$pushToast({
                type: 'informative',
                icon: true,
                text: this.$l10n.__('Période d’essai du module trésorerie expirée'),
                action: {},
                close: true,
                timeout: 20000, //20s
                unique: true,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.try-rocketchart {
    @media only screen and (max-width: 1439px) {
        padding-left: initial;
        padding-right: initial;

        .right-panel {
            width: 39vw;
            img {
                width: 100%;
            }
        }
    }
    padding-left: 72px;
    padding-right: 72px;

    &__wrapper {
        max-width: 1184px;
        display: flex;
        margin: auto;
        align-items: start;
    }
    //LEFT PANEL
    .left-panel {
        width: 480px;
        min-width: 480px;
        &__title {
            line-height: 42px;
            & + .underline {
                position: absolute;
            }
        }
        &__content {
            margin: 40px 0 0;
        }
        &__item {
            color: var(--colors-common-text-brand-secondary-blue);
            line-height: var(--line-heights-24);
            &:not(&:last-child) {
                margin-bottom: var(--spacing-3);
                padding-bottom: var(--spacing-3);
                border-bottom: solid var(--colors-common-border-default) 1px;
            }
        }
        &__links {
            margin-top: 40px;
            gap: 24px;
        }
    }

    //RIGHT PANEL
    .right-panel {
        margin-left: 116px;
        max-width: 588px;
    }

    //BOTH PANELS
    .illustration,
    .underline {
        path {
            cursor: initial;
        }
    }
}
</style>

<style lang="scss">
.page-cashflow-landingPage {
    #sellsy_app {
        background: white;
    }
    #legacy-container {
        position: relative;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
